export const PROTOCOL_REGEX = /https:\/\/|http:\/\/|www./gi;
export const URL_REGEX =
  /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PASSWORD_REGEX = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
export const NAME_REGEX =
  /^(\s*[\u0600-\u06FF\u0750-\u077F.-]\s*)+(\s*[\u0600-\u06FF\u0750-\u077F.-]+)*$|^(\s*[A-Za-z.-]\s*)+(\s*[A-Za-z.-]+)+(\s*[0-9]\s*)*$/;
export const MOBILE_REGEX = /^(\+98|0)?9\d{9}$/g;
export const ESPLIT_BY_THREE_REGEX = /.{1,3}/g;
export const ENGLISH_REGEX = /^[A-Za-z0-9]*$/;
export const POSTAL_CODE_REGEX = /(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}/;
export const NATIONAL_CODE_REGEX = !/^\d{10}$/;
export const HOME_PHONE_REGEX = /^0[0-9]{2,}[0-9]{7,}$/;
export const ENDS_WITH_MP3 = /\.mp3$/g;
export const HTTPS_REGEX = /^https?:\/\//;
